import { AxiosPromise } from 'axios';

import { Axios, AxiosService } from '@/services/Axios';
import {
  BucketFileVm,
  CreateEntityResponseVm,
  DeleteFileLegacyRequestVm,
  DeleteFileRequestVm,
} from '@/types';

export class UploadsControllerClass {
  constructor(private APIService: AxiosService) {}

  getFiles = (bucketId: string): AxiosPromise<BucketFileVm[]> => {
    return this.APIService.get(`buckets/${bucketId}/get-files`);
  };

  createTemporaryBucket = (): AxiosPromise<CreateEntityResponseVm> => {
    return this.APIService.post('buckets/create-temporary-bucket');
  };

  uploadFileLegacy = (payload, abortController): AxiosPromise<BucketFileVm> => {
    return this.APIService.postForm(
      'buckets/upload-file-legacy',
      {
        bucketId: payload.bucketId,
        category: payload.category,
        fileContent: payload.file,
        fileName: payload.file.name,
      },
      {
        signal: abortController.signal,
      },
    );
  };

  uploadFile = (payload, abortController): AxiosPromise<BucketFileVm> => {
    return this.APIService.postForm(
      'buckets/upload-file',
      {
        bucketId: payload.bucketId,
        fileName: payload.name,
        documentType: payload.fileType,
        fileContent: payload.file,
        activityId: payload.activityId,
      },
      {
        signal: abortController.signal,
      },
    );
  };

  deleteFileLegacy = (data: DeleteFileLegacyRequestVm): Promise<never> => {
    return this.APIService.delete('buckets/delete-file-legacy', { data });
  };

  deleteFile = (data: DeleteFileRequestVm): Promise<never> => {
    return this.APIService.delete('buckets/delete-file', { data });
  };

  linkBucketToRecord = (recordId: string): AxiosPromise<CreateEntityResponseVm> => {
    return this.APIService.post(`buckets/link-bucket-to-record/${recordId}`);
  };
}

export const UploadsController = new UploadsControllerClass(Axios);
